import ReactDOM from 'react-dom';
import NProgress from 'nprogress';
import App from './App';

import './global/sanitize.scss';
import './global/font-faces.scss';
import './global/typography.scss';

import './index.css';
import './nprogress.css';

NProgress.configure({ showSpinner: false });

ReactDOM.render(<App />, document.querySelector('#root'));
